import { render, staticRenderFns } from "./GrowerBarnsTab.vue?vue&type=template&id=4d48666a&scoped=true&"
import script from "./GrowerBarnsTab.vue?vue&type=script&lang=js&"
export * from "./GrowerBarnsTab.vue?vue&type=script&lang=js&"
import style0 from "./GrowerBarnsTab.vue?vue&type=style&index=0&id=4d48666a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d48666a",
  null
  
)

export default component.exports